module.exports = __webpack_public_path__ + "img/ricelog_pinicon_043.f858730d.png";